<template>
	<div style="width: 80%; margin: 0 auto; text-align: center;">
		<div style="font-size: 34px; height: 300px; line-height: 500px;">车检宝管理系统 <sub>v1.0.1</sub></div>
		<div style="padding: 50px;">
			<Form ref="formInline" :model="formInline" :rules="ruleInline" inline>
				<FormItem prop="username">
					<Input type="text" v-model="formInline.username" placeholder="用户名">
					<Icon type="ios-person-outline" slot="prepend"></Icon>
					</Input>
				</FormItem>
				<FormItem prop="password">
					<Input type="password" v-model="formInline.password" placeholder="密码">
					<Icon type="ios-lock-outline" slot="prepend"></Icon>
					</Input>
				</FormItem>
				<FormItem>
					<Button type="primary" @click="handleSubmit('formInline')">进入系统</Button>
				</FormItem>
			</Form>
		</div>
	</div>

</template>

<script>
	export default {
		data() {
			return {
				formInline: {
					username: '',
					password: ''
				},
				ruleInline: {
					username: [{
						required: true,
						message: '请输入用户名。',
						trigger: 'blur'
					}],
					password: [{
							required: true,
							message: '请输入密码。',
							trigger: 'blur'
						},
						{
							type: 'string',
							min: 6,
							message: '密码不小于6位。',
							trigger: 'blur'
						}
					]
				}
			}
		},
		methods: {
			change() {
				this.hello = '?';
				this.$Message.info({
					content: '这是一条普通的提示',
					duration: 1000
				});
			},
			handleSubmit(name) {
				var that = this;
				this.$refs[name].validate((valid) => {
					if (valid) {
						this.$Spin.show();
						this.$Loading.start();
						let thatrouter= this.$router;
						let data = {
							username: this.$data.formInline.username,
							password: this.$data.formInline.password
						};
						this.$http.post("/server/api/login.php?a=login", this.$qs.stringify(data)).then(function(res) {
							that.$Loading.finish();
							that.$Spin.hide();
							if (res.data.result == "ok") {
								that.$Message.success('登陆成功!');
								var sd={"token":res.data.data.token,"uid":res.data.data.uid};
								that.$store.commit('ADD_COUNT', sd);
								that.$router.push(that.$route.query.redirect);
							} else {
								that.$Message.error(res.data.msg);
							}
						}, function(r) {
							that.$Loading.finish();
							that.$Spin.hide();
							console.log(r)
							that.$Message.error('系统错误[http]')
						});
						//that.$store.commit('ADD_COUNT', 'res.data.data.token');
						//that.$router.push(that.$route.query.redirect);

					} else {
						this.$Message.error('Fail!');
					}
				})
			}
		},
		created: () => {
		}
	}
</script>

<style>
</style>
